/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
type StoreInterface = {
  token: string;
  isAuth: boolean;
  getDataWithExp(key: string, expiredDate: number): any | null;
  getData: (key: string) => string;
  setData: (key: string, value: any) => void;
};

class LocalStorageService {
  protected storage = localStorage;
  token = "";

  getDataWithExp = (key: string, expiredDate: number) => {
    // delay before expiration date
    const delay = 60_000;
    if (Date.now() < expiredDate - delay) {
      return this.storage[key];
    }

    return null;
  };

  setData<T>(key: string, data: T) {
    if (typeof data === "string") {
      this.storage.setItem(key, data);
    } else {
      this.storage.setItem(key, JSON.stringify(data));
    }
  }

  getData = (key: string) => {
    if (key === "s-token") {
      this.token = this.storage.getItem(key) || "";
    }

    return this.storage.getItem(key);
  };

  setDateCreate() {
    return Date.now();
  }
}

const storage = new LocalStorageService();

export type { StoreInterface };
export { storage };
